import React from 'react';
import './C2wCourseHabitCard.css'

function C2wCourseHabitCard( { obj }) {
    return (
        <div className='C2wCourseHabitCard_card'>
            <div className='heading'>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948211 13.6761 0 11.3869 0 9C0 6.61305 0.948211 4.32387 2.63604 2.63604C4.32387 0.948211 6.61305 0 9 0C11.3869 0 13.6761 0.948211 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9Z" fill="#FCAE10" />
                <path d="M5.40039 9.90078C5.40039 9.90078 6.30039 9.90078 7.20039 11.7008C7.20039 11.7008 10.0588 7.20078 12.6004 6.30078" stroke="black" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {obj?.title}
            </div>
            <div className='C2wCourseHabitCard_card_para'>
                {obj?.desc}
            </div>
        </div>
    )
}

export default C2wCourseHabitCard;
